import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=5476bae7&scoped=true&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/rich-text.scss?vue&type=style&index=0&id=5476bae7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476bae7",
  null
  
)

export default component.exports